export default function PageHeader({ title, lede, motif, motifSize = 'md', lower = false }) {
  const motifClass = motif
    ? `pagehead--with-motif pagehead--motif-${motifSize}`
    : '';
  const lowerClass = lower ? 'pagehead--lower' : '';
  // Two copies of the floated motif (only one shows per breakpoint):
  // - "lead" sits before the title → desktop: title beside the image.
  // - "inline" sits after the title → mobile: title full-width, lede wraps the image.
  const motifEl = (variant) => motif && (
    <div className={`pagehead__motif pagehead__motif--${variant}`} aria-hidden="true">
      <img src={`/imgs/${motif}`} alt="" />
    </div>
  );
  return (
    <section className={`pagehead ${motifClass} ${lowerClass}`}>
      <div className="wrap">
        <div className="pagehead__text">
          {motifEl('lead')}
          {/* Title + lede share one column so on desktop a tall motif (its own
              grid column) can never push them apart; on mobile this is just a
              normal block and the lede still wraps the inline motif. */}
          <div className="pagehead__col">
            <h1 className="pagehead__title">{title}</h1>
            {motifEl('inline')}
            <p className="pagehead__lede">{lede}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
